import {
  LightListingCard_ListingFragment,
  ListingCard_ListingFragment,
} from "@outschool/gql-frontend-generated";
import { TrackingProperties } from "@outschool/ui-legacy-component-library";

export enum TileInfoName {
  Age,
  CapacityOrDuration,
  Price,
  Lessons,
}

export type CardProps = {
  activity:
    | ListingCard_ListingFragment["activity"]
    | LightListingCard_ListingFragment["activity"];
  disabled: boolean;
  hideHeart: boolean;
  isSavedByUser: boolean;
  isLastColumn?: boolean;
  leader?:
    | ListingCard_ListingFragment["leader"]
    | LightListingCard_ListingFragment["leader"];
  linkTo?: string;
  openInNewTab?: boolean;
  trackingProperties: TrackingProperties;
  listingIndex?: number;
  variant?: string;
  insertionId:
    | ListingCard_ListingFragment["insertionId"]
    | LightListingCard_ListingFragment["insertionId"];
  isCrossSell: boolean;
  tiles: TileInfoName[];
  customOnClick?: (e: React.MouseEvent) => void;
  shareButtonFunction?: () => void;
  isCurrentlyViewing?: boolean;
  overrideShowCredits?: boolean;
  columnWidth?: number;
};
